const normalizeBaseUrl = (value = "") =>
  String(value || "")
    .trim()
    .replace(/^['"]+|['"]+$/g, "")
    .replace(/\/+$/g, "");

const BASE_URL = normalizeBaseUrl(process.env.REACT_APP_BASE_URL);

const PERFIOS_URL = process.env.REACT_APP_PERFIOS_URL || "";

const API_ENDPOINT = {
  // base url
  Base_URL: `${BASE_URL}`,

  // contact us
  contact_us: `${BASE_URL}/api/v1/contact_us`,

  //login page
  login: `${BASE_URL}/api/v1/login_view`,

  //adminlogin page
  admin_login: `${BASE_URL}/api/v1/admin_login_view`,

  // reset password
  reset_password: `${BASE_URL}/api/v1/reset_password_org`,

  change_password: `${BASE_URL}/api/v1/change_password`,

  //email verification for forgot password
  verify_email: `${BASE_URL}/api/v1/check_email_verify`,

  //forgot password
  forgot_password_send_otp: `${BASE_URL}/api/v1/forgotpassword_send_otp`,

  forgot_password_resend_otp: `${BASE_URL}/api/v1/forgotpassword_resend_otp`,

  forgot_password_verify_email_otp: `${BASE_URL}/api/v1/verify_forgotpassword_otp`,

  // unregistered vendor
  unregistered_vendor_send_otp: `${BASE_URL}/api/v1/unregistered_vendor_send_otp`,
  unregistered_vendor_verify_otp: `${BASE_URL}/api/v1/unregistered_vendor_verify_otp`,
  unregistered_vendor_set_password: `${BASE_URL}/api/v1/unregistered_vendor_set_password`,
  extract_unregistered_vendor_quotation_doc: `${BASE_URL}/api/v1/extract_unregistered_vendor_quotation_doc`,
  save_unregistered_vendor_quotation_doc: `${BASE_URL}/api/v1/save_unregistered_vendor_quotation_doc`,
  get_unregistered_vendor_quotation_doc: `${BASE_URL}/api/v1/get_unregistered_vendor_quotation_doc`,
  update_unregistered_vendor_quotation_doc: `${BASE_URL}/api/v1/update_unregistered_vendor_quotation_doc`,
  delete_unregistered_vendor_quotation_doc: `${BASE_URL}/api/v1/delete_unregistered_vendor_quotation_doc`,
  explore_unregistered_quotation_history: `${BASE_URL}/api/v1/explore_unregistered_quotation_history`,

  //buyer organization signup
  verify_company_registration_number: `${BASE_URL}/api/v1/verify_company_register_number`,

  buyer_signup: `${BASE_URL}/api/v1/buyer_registration`,

  buyer_signup_send_otp: `${BASE_URL}/api/v1/buyer_onboard_otp`,

  buyer_signup_resend_otp: `${BASE_URL}/api/v1/buyer_onboard_resend_otp`,

  buyer_signup_verify_email_otp: `${BASE_URL}/api/v1/verify_onboard_mail_otp`,

  cheque_leaf_extract: `${BASE_URL}/api/v1/cheque_leaf_extract`,

  // extract_company_details: `${BASE_URL}/api/v1/extract_certificate_details`,
  extract_company_details: `${BASE_URL}/api/v1/extract_company_details`,

  extract_mems_and_numbers: `${BASE_URL}/api/v1/extract_mems_and_numbers`,

  // pan_extract: `${BASE_URL}/api/v1/pan_extract`,
  pan_extract: `${BASE_URL}/api/v1/extract_pan_card_details`,

  extract_CIN_number: `${BASE_URL}/api/v1/extract_CIN_number`,

  extract_gst_details: `${BASE_URL}/api/v1/extract_gst_details`,

  extract_insurance_policy_number: `${BASE_URL}/api/v1/extract_insurance_policy_number`,

  extract_warranty_or_license_details: `${BASE_URL}/api/v1/extract_warranty_or_license_details`,

  // Document Verification

  pan_authentication: `${BASE_URL}/api/v1/pan_authentication`,
  gst_authentication: `${BASE_URL}/api/v1/gst_authentication`,
  cin_authentication: `${BASE_URL}/api/v1/cin_authentication`,
  msme_authentication: `${BASE_URL}/api/v1/msme_authentication`,
  bank_authentication: `${BASE_URL}/api/v1/bank_authentication`,

  // Document Check
  check_pan_format: `${BASE_URL}/api/v1/check_pan_format`,
  check_bank_format: `${BASE_URL}/api/v1/check_bank_format`,

  // manual entry

  manual_gst_check: `${BASE_URL}/api/v1/manual_gst_check`,
  manual_pan_check: `${BASE_URL}/api/v1/manual_pan_check`,
  manual_msme_check: `${BASE_URL}/api/v1/manual_msme_check`,
  manual_pan_msme_check: `${BASE_URL}/api/v1/manual_pan_msme_check`,
  manual_bank_check: `${BASE_URL}/api/v1/manual_bank_check`,
  manual_pan_cin_check: `${BASE_URL}/api/v1/manual_pan_cin_check`,
  manual_cin_check: `${BASE_URL}/api/v1/manual_cin_check`,
  corp_financial: `${BASE_URL}/api/v1/corp_financial`,
  gst_search_pan: `${BASE_URL}/api/v1/gst_search_pan`,

  send_custom_mail: `${BASE_URL}/api/v1/send_custom_mail`,

  generateQRCodeonVendorToken: `${BASE_URL}/api/v1/generateQRCodeonVendorToken`,
  generate_pdf_invoice: `${BASE_URL}/api/v1/generate_pdf_invoice`,

  // add user or buyer
  add_user: `${BASE_URL}/api/v1/user_add`,

  add_item: `${BASE_URL}/api/v1/item_add`,

  // vendor signup
  vendor_signup: `${BASE_URL}/api/v1/vendor_registration`,
  get_draft_vendor: `${BASE_URL}/api/v1/get_draft_vendor`,

  check_vendor_exists: `${BASE_URL}/api/v1/check_vendor_exists`,
  check_unified_onboarding_vendor_exists: `${BASE_URL}/api/v1/check_unified_onboarding_vendor_exists`,

  get_vendor_domain: `${BASE_URL}/api/v1/get_vendor_domain`,

  vendor_signup_send_otp: `${BASE_URL}/api/v1/vendor_onboard_otp`,

  vendor_signup_resend_otp: `${BASE_URL}/api/v1/vendor_onboard_resend_otp`,

  vendor_signup_verify_mail_otp: `${BASE_URL}/api/v1/vendor_verify_mail_otp`,

  get_draft_vendor: `${BASE_URL}/api/v1/get_draft_vendor`,

  // get all users or buyers
  get_all_users: `${BASE_URL}/api/v1/user_view`,

  // CRUD users or buyers
  update_user: `${BASE_URL}/api/v1/user_update?user_token=`,

  delete_user: `${BASE_URL}/api/v1/user_delete`,

  get_unique_user: `${BASE_URL}/api/v1/user_individual_view?user_token=`,

  //buyer shipping address
  buyer_shipping_address: `${BASE_URL}/api/v1/buyer_shipping_address?user_token=`,

  // CRUD items
  get_all_items: `${BASE_URL}/api/v1/item_view`,
  buyer_item_view: `${BASE_URL}/api/v1/buyer_item_view`,

  get_individual_item: `${BASE_URL}/api/v1/item_individual_view?item_token=`,

  get_individual_item_by_item_code: `${BASE_URL}/api/v1/item_individual_view?item_token=`,

  update_item: `${BASE_URL}/api/v1/item_update?user_token=`,

  delete_item: `${BASE_URL}/api/v1/item_delete`,

  permanent_delete_item: `${BASE_URL}/api/v1/permanant_item_delete`,

  add_bulk_items: `${BASE_URL}/api/v1/item_bulk_add`,

  //CRUD vendors
  get_all_vendor: `${BASE_URL}/api/v1/vendor_view`,

  //vendor list for organisation
  get_all_org_vendor: `${BASE_URL}/api/v1/org_vendor_list`,

  buyer_vendor_view: `${BASE_URL}/api/v1/buyer_vendor_view`,

  get_individual_vendor: `${BASE_URL}/api/v1/vendor_individual_view?`,

  //combine offline and online for vendor master
  vendor_master_full_view: `${BASE_URL}/api/v1/vendor_master_full_view`,
  vendor_master_summary_counts: `${BASE_URL}/api/v1/vendor_master_summary_counts`,


  delete_vendor: `${BASE_URL}/api/v1/vendor_delete`,

  invite_vendor: `${BASE_URL}/api/v1/invite_vendor`,
  unified_dashboard_invite_vendor: `${BASE_URL}/api/v1/unified_dashboard_invite_vendor`,
  save_unified_onboarding: `${BASE_URL}/api/v1/save_unified_onboarding`,
  get_unified_onboarding: `${BASE_URL}/api/v1/get_unified_onboarding`,
  unified_onboarding_summary_counts: `${BASE_URL}/api/v1/unified_onboarding_summary_counts`,

  add_vendor: `${BASE_URL}/api/v1/vendor_add`,

  vendor_dropdown_list: `${BASE_URL}/api/v1/vendor_dropdown_list`,

  vendordelete_in_org: `${BASE_URL}/api/v1/vendordelete_in_org`,

  get_prompt_table: `${BASE_URL}/api/v1/get_prompt_table`,

  update_prompt_table: `${BASE_URL}/api/v1/update_prompt_table`,

  list_of_prompt_category: `${BASE_URL}/api/v1/list_of_prompt_category`,

  create_prompt_table: `${BASE_URL}/api/v1/create_prompt_table`,

  get_draft_vendor: `${BASE_URL}/api/v1/get_draft_vendor`,

  //three types of RFQ

  //organisation RFQ
  get_all_org_RFQ: `${BASE_URL}/api/v1/view_org_rfq`,

  get_org_bid_view: `${BASE_URL}/api/v1/org_bid_view`,

  //buyer RFQ
  get_all_buyer_RFQ: `${BASE_URL}/api/v1/view_buyer_rfq`,
  get_free_rfq_list: `${BASE_URL}/api/v1/get_free_rfq_list`,
  get_free_rfq_vendor_quotation: `${BASE_URL}/api/v1/get_free_rfq_vendor_quotation`,
  get_free_rfq_vendor_quotation_link: `${BASE_URL}/api/v1/get_free_rfq_vendor_quotation_link`,
  get_free_rfq_detail: `${BASE_URL}/api/v1/get_free_rfq_detail`,
  send_free_rfq_buyer_chat_message: `${BASE_URL}/api/v1/send_free_rfq_buyer_chat_message`,
  send_free_rfq_vendor_chat_message: `${BASE_URL}/api/v1/send_free_rfq_vendor_chat_message`,
  get_free_rfq_vendor_chat_messages: `${BASE_URL}/api/v1/get_free_rfq_vendor_chat_messages`,
  get_free_rfq_buyer_chat_threads: `${BASE_URL}/api/v1/get_free_rfq_buyer_chat_threads`,
  create_easy_rfq_id: `${BASE_URL}/api/v1/create_easy_rfq_id`,
  buyer_rfq_full_view: `${BASE_URL}/api/v1/buyer_rfq_full_view`,
  free_rfq: `${BASE_URL}/api/v1/free_rfq`,
  start_free_rfq_vendor_quotation_extraction: `${BASE_URL}/api/v1/free_rfq_vendor_quotation_extract_async`,
  get_free_rfq_vendor_quotation_extraction: `${BASE_URL}/api/v1/free_rfq_vendor_quotation_extract_status`,
  save_free_rfq_vendor_quotation: `${BASE_URL}/api/v1/save_free_rfq_vendor_quotation`,

  new_RFQ: `${BASE_URL}/api/v1/add_rfq_multiple_item`,

  edit_RFQ: `${BASE_URL}/api/v1/multiple_item_rfq_update?rfq_token=`,

  delete_RFQ: `${BASE_URL}/api/v1/rfq_delete?rfq_token=`,

  rfq_vendor_email_verification: `${BASE_URL}/api/v1/vendor_email_verification`,

  rfq_comparison_nanonets: `${BASE_URL}/api/v1/nanonets_comparison?buyer_token=`,

  rfq_comparison_azure: `${BASE_URL}/api/v1/azure_comparison?buyer_token=`,

  rfq_comparison_GPT: `${BASE_URL}/api/v1/chatgpt`,

  rfq_comparison_DOCSUMO: `${BASE_URL}/api/v1/comparison_docsumo`,

  rfq_newversion_chatgpt: `${BASE_URL}/api/v1/rfq_newversion_chatgpt`,

  comparison_rfq_history: `${BASE_URL}/api/v1/comparison_rfq_history`,
  comparison_item_po_price_history: `${BASE_URL}/api/v1/comparison_item_po_price_history`,

  rfq_add_new_vendor: `${BASE_URL}/api/v1/rfq_add_new_vendor`,

  enable_vendor_list: `${BASE_URL}/api/v1/enable_vendor_list`,

  list_of_msg: `${BASE_URL}/api/v1/list_of_msg`,

  get_purchase_order_list: `${BASE_URL}/api/v1/get_purchase_order_list`,

  // Vendor PO list
  get_vendor_purchase_order_list: `${BASE_URL}/api/v1/get_vendor_purchase_order_list`,

  create_selected_PO: `${BASE_URL}/api/v1/create_selected_PO`,

  update_purchase_order: `${BASE_URL}/api/v1/update_purchase_order`,

  detele_purchase_order: `${BASE_URL}/api/v1/detele_purchase_order`,

  send_email_purchase_order: `${BASE_URL}/api/v1/send_email_purchase_order`,

  send_unregistered_vendor_interest_mail: `${BASE_URL}/api/v1/send_unregistered_vendor_interest_mail`,

  completed_pr_rfq_draft: `${BASE_URL}/api/v1/completed_pr_rfq_draft`,

  //items view for new rfq
  view_all_item: `${BASE_URL}/api/v1/view_all_item`,

  //Vendor RFQ
  vendor_csv_upload: `${BASE_URL}/api/v1/vendor_csv_upload`,

  get_all_vendor_RFQ: `${BASE_URL}/api/v1/view_vendor_rfq`,

  get_vendor_all_bids: `${BASE_URL}/api/v1/vendor_bid_view`,

  update_vendor: `${BASE_URL}/api/v1/vendor_update?vendor_token=`,

  update_encrypt_data_in_vendor: `${BASE_URL}/api/v1/update_encrypt_data_in_vendor?vendor_token=`,

  add_bids: `${BASE_URL}/api/v1/new_add_bids`,

  vendor_bid_delete: `${BASE_URL}/api/v1/vendor_bid_delete`,

  select_bid: `${BASE_URL}/api/v1/select_bid`,

  get_vendor_contacts: `${BASE_URL}/api/v1/vendor_user_list`,

  add_vendor_contact: `${BASE_URL}/api/v1/add_vendor_contact`,

  delete_vendor_contact: `${BASE_URL}/api/v1/vendorcontact_delete`,

  get_individual_RFQ: `${BASE_URL}/api/v1/rfq_individual_items_view?rfq_token=`,

  requote_bid: `${BASE_URL}/api/v1/resubmit_request_email`,
  
  free_rfq_resubmit_request_email: `${BASE_URL}/api/v1/free_rfq_resubmit_request_email`,

  negotiation_bot_history: `${BASE_URL}/api/v1/negotiation_bot_history`,

  negotiation_bot_request_revision: `${BASE_URL}/api/v1/negotiation_bot_request_revision`,

  negotiation_bot_offer_submit: `${BASE_URL}/api/v1/negotiation_bot_offer_submit`,

  negotiation_bot_session_detail: `${BASE_URL}/api/v1/negotiation_bot_session_detail`,

  buyer_negotiation_sessions: `${BASE_URL}/api/v1/buyer_negotiation_sessions`,

  vendor_negotiation_sessions: `${BASE_URL}/api/v1/vendor_negotiation_sessions`,

  negotiation_bot_vendor_messages: `${BASE_URL}/api/v1/negotiation_bot_vendor_messages`,

  negotiation_bot_vendor_session_detail: `${BASE_URL}/api/v1/negotiation_bot_vendor_session_detail`,

  negotiation_bot_buyer_message: `${BASE_URL}/api/v1/negotiation_bot_buyer_message`,

  negotiation_bot_vendor_message: `${BASE_URL}/api/v1/negotiation_bot_vendor_messages`,

  vendor_msg_box: `${BASE_URL}/api/v1/vendor_msg_box`,

  rfq_chat_box: `${BASE_URL}/api/v1/rfq_chat_box`,

  //comparison analytics list

  comparison_analytics: `${BASE_URL}/api/v1/comparison_files`,

  // dashboard analytics apis
  buyer_dashboard: `${BASE_URL}/api/v1/buyer_dashbord`,

  new_buyer_dashbord: `${BASE_URL}/api/v1/new_buyer_dashbord`,
  user_dashboard: `${BASE_URL}/api/v1/user_dashboard`,
  buyer_admin_dashboard: `${BASE_URL}/api/v1/buyer_admin_dashboard`,
  get_pr_details_by_org_token: `${BASE_URL}/api/v1/get_pr_details_by_org_token`,

  org_dashboard: `${BASE_URL}/api/v1/org_dashboard`,

  new_org_dashboard: `${BASE_URL}/api/v1/new_org_dashboard`,

  vendor_dashboard: `${BASE_URL}/api/v1/vendor_dashbord`,

  vendor_dashboard_new: `${BASE_URL}/api/v1/vendor_dashbord_new`,

  new_vendor_dashbord: `${BASE_URL}/api/v1/new_vendor_dashbord`,

  getBuyerList: `${BASE_URL}/api/v1/customer_list`,

  getItemCodes: `${BASE_URL}/api/v1/item_code_list`,

  getCompanyList: `${BASE_URL}/api/v1/company_list`,

  getOrgBuyerList: `${BASE_URL}/api/v1/buyer_list`,

  getNotifications: `${BASE_URL}/api/v1/notifications`,

  unreadNotifications: `${BASE_URL}/api/v1/unread_notification`,

  vendor_customer_list: `${BASE_URL}/api/v1/vendor_customer_list`,

  vendor_company_list: `${BASE_URL}/api/v1/vendor_company_list`,

  user_update_data_encrypt: `${BASE_URL}/api/v1/user_update_data_encrypt?user_token=`,

  trigger_status_email: `${BASE_URL}/api/v1/trigger-status-email`,

  //org download list apis
  csv_user_view: `${BASE_URL}/api/v1/csv_user_view`,
  csv_org_vendor_list: `${BASE_URL}/api/v1/csv_org_vendor_list`,
  csv_view_org_rfq: `${BASE_URL}/api/v1/csv_view_org_rfq`,
  csv_org_item_view: `${BASE_URL}/api/v1/csv_org_item_view`,
  csv_buyer_item_view: `${BASE_URL}/api/v1/csv_buyer_item_view`,
  csv_vendor_user_list: `${BASE_URL}/api/v1/csv_vendor_user_list`,

  vendor_csv_rfq: `${BASE_URL}/api/v1/vendor_csv_rfq`,

  buyer_rfq_csv: `${BASE_URL}/api/v1/buyer_rfq_csv`,

  purchase_order_csv: `${BASE_URL}/api/v1/purchase_order_csv`,

  buyer_vendor_csv: `${BASE_URL}/api/v1/buyer_vendor_csv`,
  csv_buyer_vendor_list: `${BASE_URL}/api/v1/csv_buyer_vendor_list`,

  vendor_csv_rfq: `${BASE_URL}/api/v1/vendor_csv_rfq`,

  get_pr_rfq_draft: `${BASE_URL}/api/v1/get_pr_rfq_draft`,

  delete_pr_rfq_draft: `${BASE_URL}/api/v1/delete_pr_rfq_draft`,

  //country state city dropdown APIs
  view_countries: `${BASE_URL}/api/v1/view_countries`,
  view_state: `${BASE_URL}/api/v1/view_state`,
  view_cities: `${BASE_URL}/api/v1/view_cities`,
  all_view_states: `${BASE_URL}/api/v1/all_view_states`,
  all_view_cities: `${BASE_URL}/api/v1/all_view_cities`,
  rfq_chat: `${BASE_URL}/api/v1/rfq_chat`,
  view_rfq_chat: `${BASE_URL}/api/v1/view_rfq_chat`,
  view_rfq_vendors: `${BASE_URL}/api/v1/view_rfq_vendors`,

  // compair bidz in websocket
  check_prn_number_unic: `${BASE_URL}/api/v1/check_prn_number_unic`,
  newversion_chatgpt: `${BASE_URL}/api/v1/newversion_chatgpt`,
  updated_chatgpt_compare: `${BASE_URL}/api/v1/updated_chatgpt_compare`,
  response_data: `${BASE_URL}/api/v1/response_data`,
  comparison_history: `${BASE_URL}/api/v1/comparison_history`,

  // get All Department
  get_Department: `${BASE_URL}/api/v1/org_department_list`,

  // Get user List
  user_list: `${BASE_URL}/api/v1/org_users_list`,
  only_users: `${BASE_URL}/api/v1/only_users`,

  //slab Config
  slab_config: `${BASE_URL}/api/v1/slab_config`,
  slab_config_list: `${BASE_URL}/api/v1/slab_config_list`,
  // Cost Center
  add_cost_center: `${BASE_URL}/api/v1/add_cost_center`,
  cost_center_list: `${BASE_URL}/api/v1/cost_center_list`,
  delete_cost_center: `${BASE_URL}/api/v1/delete_cost_center_code`,
  add_bulkcode: `${BASE_URL}/api/v1/add_bulkcode`,

  // GL
  add_gl_code: `${BASE_URL}/api/v1/add_gl_code`,
  gl_code_list: `${BASE_URL}/api/v1/gl_code_list`,
  delete_gl_code: `${BASE_URL}/api/v1/delete_gl_code`,
  add_bulkglcode: `${BASE_URL}/api/v1/add_bulkglcode`,

  // Projects
  add_projects: `${BASE_URL}/api/v1/add_projects`,
  projects_list: `${BASE_URL}/api/v1/projects_list`,
  delete_projects: `${BASE_URL}/api/v1/delete_project_code`,
  add_bulkprojectcode: `${BASE_URL}/api/v1/add_bulkprojectcode`,

  // GST
  add_gst: `${BASE_URL}/api/v1/add_gst`,
  gst_list: `${BASE_URL}/api/v1/gst_list`,

  get_all_gst: `${BASE_URL}/api/v1/get_all_gst`,

  tax_bulk_add: `${BASE_URL}/api/v1/tax_bulk_add`,

  hierarchy_approval: `${BASE_URL}/api/v1/hierarchy_approval`,
  approvalNotifications: `${BASE_URL}/api/v1/approval_notifications`,

  // dashboard urls
  spend_item_view: `${BASE_URL}/api/v1/spend_item_view`,

  all_user_list: `${BASE_URL}/api/v1/all_user_list`,

  user_chat_message: `${BASE_URL}/api/v1/user_chat_message`,

  get_user_messages: `${BASE_URL}/api/v1/get_user_messages`,

  get_chat_messages: `${BASE_URL}/api/v1/get_chat_messages`,

  get_purchase_order: `${BASE_URL}/api/v1/get_purchase_order`,
  get_invoice_purchase_order: `${BASE_URL}/api/v1/get_invoice_purchase_order`,

  ins_grn_data: `${BASE_URL}/api/v1/ins_grn_data`,

  get_saved_grn: `${BASE_URL}/api/v1/get_saved_grn`,
  //grn approver
  approve_grn: `${BASE_URL}/api/v1/approve_grn`,

  // Asset Register
  create_asset_register_after_grn: `${BASE_URL}/api/v1/create_asset_register_after_grn`,
  get_asset_register: `${BASE_URL}/api/v1/get_asset_register`,
  get_asset_summary: `${BASE_URL}/api/v1/get_asset_summary`,

  rfq_timeline_messages: `${BASE_URL}/api/v1/rfq_timeline_messages`,

  rfq_address: `${BASE_URL}/api/v1/rfq_address`,

  save_quick_rfq: `${BASE_URL}/api/v1/save_quick_rfq`,

  get_saved_prs: `${BASE_URL}/api/v1/get_saved_prs`,

  update_is_purchase_request: `${BASE_URL}/api/v1/update_is_purchase_request`,

  ins_purchase_request: `${BASE_URL}/api/v1/ins_purchase_request`,

  purchase_request_individual_items_view: `${BASE_URL}/api/v1/purchase_request_individual_items_view`,

  combined_saved_pr_with_items_view: `${BASE_URL}/api/v1/combined_saved_pr_with_items_view`,

  get_user_mapped_prs: `${BASE_URL}/api/v1/get_user_mapped_prs`,

  approve_pr: `${BASE_URL}/api/v1/approve_pr`,

  extractdoc: `${BASE_URL}/api/v1/extractdoc`,

  ins_pr_slab_config: `${BASE_URL}/api/v1/ins_pr_slab_config`,

  get_all_po_slab: `${BASE_URL}/api/v1/get_all_po_slab`,

  get_all_saved_prs_code: `${BASE_URL}/api/v1/get_all_saved_prs_code`,

  delete_pr_slab_config: `${BASE_URL}/api/v1/delete_pr_slab_config`,
  delete_twm_slab_config: `${BASE_URL}/api/v1/delete_twm_slab_config`,

  invite_vendor: `${BASE_URL}/api/v1/invite_vendor`,

  validate_vendor_token: `${BASE_URL}/api/v1/validate_vendor_token`,

  invoice_generate: `${BASE_URL}/api/v1/invoice_generate`,

  get_vendor_invoice: `${BASE_URL}/api/v1/get_vendor_invoice`,

  get_vendor_invoice_test: `${BASE_URL}/api/v1/get_vendor_invoice_test`,

  get_all_vendor_invoices: `${BASE_URL}/api/v1/get_all_vendor_invoices`,

  get_all_invoices: `${BASE_URL}/api/v1/get_all_invoices`,

  approve_vendor_invoice: `${BASE_URL}/api/v1/approve_vendor_invoice`,

  bulk_approve_vendor_invoices: `${BASE_URL}/api/v1/bulk_approve_vendor_invoices`,

  sign_invoice: `${BASE_URL}/api/v1/sign_invoice`,

  // OLD API - deprecated after dashboard summary merge
  invoicecardcount: `${BASE_URL}/api/v1/invoicecardcount`,
  // OLD API - deprecated after dashboard summary merge
  invoice_summary: `${BASE_URL}/api/v1/invoice_summary`,
  // OLD API - deprecated after dashboard summary merge
  vendor_onboard_summary: `${BASE_URL}/api/v1/vendor_onboard_summary`,
  // OLD API - deprecated after dashboard summary merge
  vendor_invoice_status_summary: `${BASE_URL}/api/v1/vendor_invoice_status_summary`,
  // OLD API - deprecated after dashboard summary merge
  vendor_onboard_trend: `${BASE_URL}/api/v1/vendor_onboard_trend`,
  // OLD API - deprecated after dashboard summary merge
  monthly_invoice_summary: `${BASE_URL}/api/v1/monthly_invoice_summary`,

  // Vendor invoice reconciliation summary
  get_vendor_invoice_conciliation_summary: `${BASE_URL}/api/v1/get_vendor_invoice_conciliation_summary`,
  get_buyer_invoice_reconciliation: `${BASE_URL}/api/v1/get_buyer_invoice_reconciliation`,

  // Unified merchant invoice dashboard summary
  merchant_invoice_dashboard_summary: `${BASE_URL}/api/v1/merchant_invoice_dashboard_summary`,

  gst_filing_details: `${BASE_URL}/api/v1/gst_filing_details`,

  merchant_invoice_delay_tracker: `${BASE_URL}/api/v1/merchant_invoice_delay_tracker`,

  get_all_vendors_approval: `${BASE_URL}/api/v1/get_all_vendors_approval`,
  vendor_approve: `${BASE_URL}/api/v1/vendor_approve`,

  bulk_document_verification: `${BASE_URL}/api/v1/bulk_document_verification`,
  fetch_all_bulk_verification: `${BASE_URL}/api/v1/fetch_all_bulk_verification`,
  fetch_verificaton_logs: `${BASE_URL}/api/v1/fetch_verificaton_logs`,

  get_vendor_verification_logs: `${BASE_URL}/api/v1/get_vendor_verification_logs`,

  save_corporate_credit: `${BASE_URL}/api/v1/save_corporate_credit`,

  // super admin

  all_buyer_admin: `${BASE_URL}/api/v1/all_buyer_admin`,
  fetch_all_menu: `${BASE_URL}/api/v1/fetch_all_menu`,
  licenseActivate: `${BASE_URL}/api/v1/licenseActivate`,
  check_active_license: `${BASE_URL}/api/v1/check_active_license`,
  invite_buyer_admin: `${BASE_URL}/api/v1/invite_buyer_admin`,
  all_user_activity: `${BASE_URL}/api/v1/all-user-activity`,
  superadmin_ai_usage_cost_accuracy: `${BASE_URL}/api/v1/superadmin_ai_usage_cost_accuracy`,

  // test apis idfy's

  get_request_id: `${BASE_URL}/api/v1/get_request_id`,
  get_gst_details: `${BASE_URL}/api/v1/get_gst_details`,

  send_otp_to_email: `${BASE_URL}/api/v1/send_otp_to_email`,
  verify_otp: `${BASE_URL}/api/v1/verify_otp`,
  save_demo_user: `${BASE_URL}/api/v1/save_demo_user`,
  get_demo_user_details: `${BASE_URL}/api/v1/get_demo_user_details`,

  compare_rfq_api: `${BASE_URL}/api/v1/compare_rfq_api`,
  get_compare_rfq: `${BASE_URL}/api/v1/get_compare_rfq`,
  get_induvial_compare: `${BASE_URL}/api/v1/get_induvial_compare`,

  bulk_pan_to_msme_and_cin: `${BASE_URL}/api/v1/bulk_pan_to_msme_and_cin`,

  // three way matching
  save_three_way_matching: `${BASE_URL}/api/v1/save_three_way_matching`,
  get_three_way_matching: `${BASE_URL}/api/v1/get_three_way_matching`,
  get_three_way_matching_summary: `${BASE_URL}/api/v1/get_three_way_matching_summary`,
  approve_reject_twm: `${BASE_URL}/api/v1/approve_reject_twm`,
  peek_next_twm_code: `${BASE_URL}/api/v1/peek_next_twm_code`,
  bulk_three_way_matching: `${BASE_URL}/api/v1/bulk_three_way_matching`,
  get_bulk_twm_status: `${BASE_URL}/api/v1/get_bulk_twm_status`,
  get_bulk_twm_results: `${BASE_URL}/api/v1/get_bulk_twm_results`,
  get_bulk_twm_summary: `${BASE_URL}/api/v1/get_bulk_twm_summary`,
  get_bulk_three_way_matching: `${BASE_URL}/api/v1/get_bulk_three_way_matching`,
  save_bulk_three_way_matching: `${BASE_URL}/api/v1/save_bulk_three_way_matching`,

  //three combine api
  get_three_way_matching_with_approvers: `${BASE_URL}/api/v1/get_three_way_matching_with_approvers`,


  ins_twm_slab_config: `${BASE_URL}/api/v1/ins_twm_slab_config`,
  get_all_twm_slab: `${BASE_URL}/api/v1/get_all_twm_slab`,
  get_twm_approver_names: `${BASE_URL}/api/v1/get_twm_approver_names`,

  // chatbot
  get_chat_buyers: `${BASE_URL}/api/v1/get_chat_buyers`,
  chat_bot_api: `${BASE_URL}/api/v1/chat_bot_api`,
  user_chat_bot_message: `${BASE_URL}/api/v1/user_chat_bot_message`,
  create_pr_from_email_request: `${BASE_URL}/api/v1/create_pr_from_email_request`,

  // Rate contract
  get_saved_ract_contracts: `${BASE_URL}/api/v1/get_saved_ract_contracts`,

  // rate contract
  extract_pdf_view: `${BASE_URL}/api/v1/extract_pdf_view`,
  get_saved_rate_contracts: `${BASE_URL}/api/v1/get_saved_rate_contracts`,
  get_rc_items_: `${BASE_URL}/api/v1/get_rc_items_`,
  convert_rate_contract_to_po: `${BASE_URL}/api/v1/convert_rate_contract_to_po`,
  save_extracted_rate_contract: `${BASE_URL}/api/v1/save_extracted_rate_contract`,
  filter_price_catalog: `${BASE_URL}/api/v1/filter_price_catalog`,
  save_price_catalog_filter: `${BASE_URL}/api/v1/save_price_catalog_filter`,
  get_price_catalog_filter: `${BASE_URL}/api/v1/get_price_catalog_filter`,
  //combine rate contract
  get_combine_rcList: `${BASE_URL}/api/v1/get-saved-rate-contracts-with-items`,
  extract_pdf_no_filter_view :`${BASE_URL}/api/v1/extract_pdf_no_filter_view`,


  // vendor profile verify status
  update_vendor_documents_status: `${BASE_URL}/api/v1/update_vendor_documents_status`,

  // vendor Invoice Process:

  upload_vendor_invoice_document: `${BASE_URL}/api/v1/upload_vendor_invoice_document`,
  upload_vendor_po_invoice_documents: `${BASE_URL}/api/v1/upload_vendor_po_invoice_documents`,
  save_vendor_invoice_document_data: `${BASE_URL}/api/v1/save_vendor_invoice_document_data`,
  save_vendor_po_invoice_document_data: `${BASE_URL}/api/v1/save_vendor_po_invoice_document_data`,
  get_vendor_invoices: `${BASE_URL}/api/v1/get_vendor_invoices`,
  get_vendor_invoice_document_approval_queue: `${BASE_URL}/api/v1/get_vendor_invoice_document_approval_queue`,
  approve_vendor_invoice_document: `${BASE_URL}/api/v1/approve_vendor_invoice_document`,
  get_zoho_datas: `${BASE_URL}/api/v1/get_zoho_datas`,
  get_invoices_by_org_token: `${BASE_URL}/api/v1/get_invoices_by_org_token`,
  // GRN


  // get_all_category : `${BASE_URL}/api/v1/get_all_category`,
  // get_all_Items : `${BASE_URL}/api/v1/get_all_Items`,
  // save_item_entry : `${BASE_URL}/api/v1/save_item_entry`,
  // save_vendor_mapping : `${BASE_URL}/api/v1/save_vendor_mapping`,
  // get_all_Items_table : `${BASE_URL}/api/v1/get_all_Items_table`,
  // get_mapped_vendors : `${BASE_URL}/api/v1/get_mapped_vendors`,


  // vendor Item mapping


  buyer_all_item_list: `${BASE_URL}/api/v1/buyer_all_item_list`,
  item_vendor_mapping_create: `${BASE_URL}/api/v1/item-vendor-mapping/create/`,
  vendors_by_category: `${BASE_URL}/api/v1/vendors/by-category/`,
  vendors_item_mapping_list: `${BASE_URL}/api/v1/item-vendor-mapping/items/`,

  // Offline password

offline_password_create: `${BASE_URL}/api/v1/offline_password_create`,
offline_password_list: `${BASE_URL}/api/v1/offline_password_list`,
  offline_password_update: `${BASE_URL}/api/v1/offline_password_update`,

  // Inventory Master and Warehouse
  warehouse_master: `${BASE_URL}/api/v1/warehouse_master`,
  get_warehouse_master: `${BASE_URL}/api/v1/get_warehouse_master`,
  inventory_master: `${BASE_URL}/api/v1/inventory_master`,
  get_inventory_master: `${BASE_URL}/api/v1/get_inventory_master`,
  approved_grn_items_for_inventory: `${BASE_URL}/api/v1/approved_grn_items_for_inventory`,
  material_issue: `${BASE_URL}/api/v1/material_issue`,
  get_material_issued: `${BASE_URL}/api/v1/get_material_issued`,
  stock_movement: `${BASE_URL}/api/v1/stock_movement`,
  stock_transfer: `${BASE_URL}/api/v1/stock_transfer`,
  stock_ledger: `${BASE_URL}/api/v1/stock_ledger`,
  consumption_report: `${BASE_URL}/api/v1/consumption_report`,
  inventory_grns: `${BASE_URL}/api/v1/inventory/grns`,

};



export { API_ENDPOINT };
